// BuildingDeviceEditing.js

import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../../../../Constants";

const BuildingDeviceEditing = () => {
    const [buildingData, setBuildingData] = useState({});
    const [address,setAddress] = useState("");
    const [deviceData, setDeviceData] = useState([]);
    const [displayedData, setDisplayedData] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [searchCriteria, setSearchCriteria] = useState('none');
    const [editEnabled, setEditEnabled] = useState(false);
    const [editedRecords, setEditedRecords] = useState([]);
    const [showingInspections, setShowingInspections] = useState(false);
    const [inspectionsData, setInspectionsData] = useState([]);
    const [listLoadingStatus, setListLoadingStatus] = useState(false);
    const [listLoadingStatusMessage, setListLoadingStatusMessage] = useState("Loading...");
    const { buildingId } = useParams();
    const navigate = useNavigate();

    const deviceFields = [
        { key: "deviceId", value: "N/A" },
        { key: "deviceClass", value: "N/A" },
        { key: "currentSubclass", value: "N/A" },
        { key: "deviceSubclass", value: "N/A" },
        { key: "deviceType", value: "N/A" },
        { key: "deviceUse", value: "N/A" },
        { key: "agencyId", value: "N/A" },
        { key: "customerId", value: "N/A" },
        { key: "borough", value: "N/A" },
        { key: "capacity", value: "N/A" },
        { key: "carSpeed", value: "N/A" },
        { key: "floorCount", value: "N/A" },
        { key: "travel", value: "N/A" },
        
        // Do we need these?
        { key: "hoistMotorType", value: "N/A" },
        { key: "hoistMotorACDC", value: "N/A" },
        { key: "controlBoardMake", value: "N/A" },
        { key: "controlBoardType", value: "N/A" },
        { key: "shaftwayDoorType", value: "N/A" },
        //

        { key: "machineType", value: "N/A" },
    ];
    
    const inspectionFields = [
        { key: "inspectionId", value: "N/A" },
        { key: "deviceId", value: "N/A" },
        { key: "deviceType", value: "N/A" },
        { key: "test1", value: "N/A" },
        { key: "test1LastDate", value: "N/A" },
        { key: "test1NextDate", value: "N/A" },
        { key: "test1Perform", value: "N/A" },
        { key: "test1BillType", value: "N/A" },
        { key: "test1Amount", value: "N/A" },
        { key: "test2", value: "N/A" },
        { key: "test2LastDate", value: "N/A" },
        { key: "test2NextDate", value: "N/A" },
        { key: "test2Perform", value: "N/A" },
        { key: "test2BillType", value: "N/A" },
        { key: "test2Amount", value: "N/A" },
        { key: "inspectionStatus", value: "N/A" },
        { key: "carNote", value: "N/A" },
        { key: "routeId", value: "N/A" },
        { key: "location", value: "N/A" },
        { key: "customer", value: "N/A" },
        { key: "agency", value: "N/A" },
    ];
    

    const deviceSubclassFields = [
        { key: "Drum", values: ["Overhead", "Basement", "Private Residence", "LULA", "Dumbwaiter", "Sidewalk"] },
        { key: "Traction", values: ["Gearless", "Geared Overhead", "Geared Basement", "Machine Room-less"] },
        { key: "Hydraulic", values: ["Boreholed", "Holeless", "Roped", "Water", "Private Residence", "LULA", "Dumbwaiter"] }
    ];

    const deviceUseFields = [
        { key: "deviceUse", values: ["Passenger", "Freight", "Material Lift", "Construction Use", "Dumbwaiter", "LULA"] }
    ];

    const deviceTypeFields = ["Conveyor", "Dumbwaiter", "Freight", "Escalator"];



    useEffect(() => {
        if (buildingId) {
            fetchBuilding();
        } else {
            console.error('Building ID not provided');
            navigate('/error', { state: { message: 'Building ID not provided' } });
        }
    }, [buildingId ]);




    const fetchBuilding = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/setup/buildings/${buildingId}`, { credentials: 'include' });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const buildingData = await response.json();
            setBuildingData(buildingData);

            fetchRecords(buildingId);
            setAddress(buildingData.address.physicalStreet1)
            
        } catch (error) {
            console.error('Fetch error: ', error);
        }
    };

    useEffect( ()=> {
        if(deviceData.length === 0 && !showingInspections && listLoadingStatus){
            console.log(deviceData.length + ", " + listLoadingStatus);

            setListLoadingStatusMessage("No devices for this building found");
        }
        else if(inspectionsData.length === 0 && showingInspections && listLoadingStatus){
            console.log(deviceData.length + ", " + listLoadingStatus);


            setListLoadingStatusMessage("No inspections for this building found");
        }
    },[showingInspections,listLoadingStatus])


    const fetchRecords = async (buildingId) => {

        try {
            const deviceResponse = await fetch(`${API_BASE_URL}/api/setup/buildings/devices/${buildingId}`, { credentials: 'include' });

            if (!deviceResponse.ok) {
                console.log("Device Data:", deviceResponse);
                throw new Error('Network response was not ok');
            }

            const recordData = await deviceResponse.json();

            // Check if any devices were returned

            // Set the merged data
            setDeviceData(recordData);
            setDisplayedData(recordData);

        } catch (error) {
            console.error('Fetch error: ', error);

        }

        try {
            const inspectResponse = await fetch(`${API_BASE_URL}/api/admin/inspections/building/${buildingId}`, { credentials: 'include' });

            if (!inspectResponse.ok) {

                throw new Error('Network response was not ok');
            }

            const inspectionData = await inspectResponse.json();
            // Set the merged data
            setInspectionsData(inspectionData);
            console.log(inspectionData)
        } catch (error) {
            console.error('Fetch error: ', error);

        }
        setListLoadingStatus(true);

    };







    const handleDeleteDevice = async (id) => {
        const confirmDelete = window.confirm("Are you sure you would like to delete this record?");
        if (!confirmDelete) {
            return;
        } 
        try {
            const formResponse = await fetch(`${API_BASE_URL}/api/setup/buildings/devices/${id}`, {
                credentials: 'include',
                method: 'DELETE',
            });
            if (formResponse.ok) {
                fetchBuilding();
            } else {
                alert('Record Not Deleted');
            }
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const handleDeleteInspection = async (id) => {
        console.log(id)
        const confirmDelete = window.confirm("Are you sure you would like to delete this inspection record?");
        if (!confirmDelete) {
            return;
        } 
        try {
            const formResponse = await fetch(`${API_BASE_URL}/api/admin/inspections/delete/buildingInspection/${id}`, {
                credentials: 'include',
                method: 'DELETE',
            });
            if (formResponse.ok) {
                fetchBuilding();
            } else {
                alert('Record Not Deleted');
            }
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };



    const handleEdit = () => {
        setEditEnabled(prev => !prev);
    };

    const handleSearchChange = (target) => {
        setSearchInput(target);
    };



    const handleInputChange = (event, index, key) => {
        const updatedData = [...displayedData];


        updatedData[index][key] = event.target.value;
        if (key === 'deviceSubclass') {
            updatedData[index]['currentSubclass'] = event.target.value;
        }
        if (!editedRecords.includes(index)) {
            setEditedRecords((prev) => [...prev, index]);
        }
        if(showingInspections){
            setInspectionsData(updatedData)
        }
        else{
            setDeviceData(updatedData)
        }

        console.log(editedRecords)
        setDisplayedData(updatedData);
    };



    const handleDeviceListChange = (val) => {
        if(editEnabled){
            setEditEnabled(false)
        } 
        setDisplayedData(() => (val ? inspectionsData : deviceData));
       
        setShowingInspections(val);
    }



    const handleSubmit = async () => {
        setEditEnabled(false);

        console.log(deviceData)
        console.log(inspectionsData)


        for (const index of editedRecords) {
            console.log(index)
            console.log(displayedData[index])

            try {
                if (showingInspections) {
                    // Send inspectResponse when showInspections is true
                    const inspectResponse = await fetch(
                        `${API_BASE_URL}/api/admin/inspections/buildingdevice/id/${displayedData[index].inspectionId}`,
                        {
                            method: 'PUT',
                            credentials: 'include',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                buildingId: 1,
                                deviceId: displayedData[index].deviceId,
            
                                test1: displayedData[index].test1,                         
                                test1LastDate: displayedData[index].test1LastDate,          
                                test1NextDate: displayedData[index].test1NextDate,
                                test1Perform: displayedData[index].test1Perform,
                                test1BillType: displayedData[index].test1BillType,
                                test1Amount: displayedData[index].test1Amount,
            
                                test2: displayedData[index].test2,
                                test2LastDate: displayedData[index].test2LastDate,
                                test2NextDate: displayedData[index].test2NextDate,
                                test2Perform: displayedData[index].test2Perform,
                                test2BillType: displayedData[index].test2BillType,
                                test2Amount: displayedData[index].test2Amount,
            
                                inspectionStatus: displayedData[index].inspectionStatus,
                                inspectionId: displayedData[index].inspectionId,
                                carNote: displayedData[index].carNote,
                                routeId: displayedData[index].routeId,
                                location: displayedData[index].location,
                                customer: displayedData[index].customer,
                            }),
                        }
                    );
            
                    if (!inspectResponse.ok) {
                        alert('Inspection record not updated');
                    }
                } else {
                    // Send formResponse when showInspections is false
                    const formResponse = await fetch(
                        `${API_BASE_URL}/api/setup/buildings/devices/${displayedData[index].deviceId}`,
                        {
                            method: 'PUT',
                            credentials: 'include',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                deviceId: displayedData[index].deviceId,
                                deviceClass: displayedData[index].deviceClass,
                                currentSubclass: displayedData[index].deviceSubclass,
                                deviceSubclass: displayedData[index].deviceSubclass,
                                deviceUse: displayedData[index].deviceUse,
                                deviceType: displayedData[index].deviceType,
                                customerId: displayedData[index].customerId,
                                borough: displayedData[index].borough,
                                capacity: displayedData[index].capacity,
                                carSpeed: displayedData[index].carSpeed,
                                floorCount: displayedData[index].floors,
                                travel: displayedData[index].travel,
                                hoistMotorType: displayedData[index].hoistMotorType,
                                hoistMotorACDC: displayedData[index].hoistMotorACDC,
                                controlBoardMake: displayedData[index].controlBoardMake,
                                controlBoardType: displayedData[index].controlBoardType,
                                shaftwayDoorType: displayedData[index].shaftwayDoorType,
                                machineType: displayedData[index].machineType,
                                buildingId: displayedData[index].buildingId,
                            }),
                        }
                    );
            
                    if (!formResponse.ok) {
                        alert('Device record not updated');
                    }
                }
            } catch (error) {
                console.error('Error updating record:', error);
            }
            
            
        }
        setEditedRecords([]);
    };

    useEffect(() => {
        if (searchInput === "" || searchCriteria === 'none') {
            setDisplayedData(deviceData);
        } 
        else {
            try{
                setDisplayedData(
                    deviceData.filter((device) =>
                        device[searchCriteria]?.toLowerCase().startsWith(searchInput.toLowerCase())
                    )
                );
            }
            catch(error){
                console.log("Number cant be lowercase")
            }
        }
    }, [searchInput, searchCriteria, deviceData]);


    const deviceRender = () => {
        return (
            // Inspections selected
            (showingInspections ?
                <tbody className="w-full">
                    {inspectionsData.length > 0 ? displayedData.slice(0, inspectionsData.length).map((device, index) => (
                        
                        <tr key={index} className="justify-center border">
                            {!editEnabled
                                ? inspectionFields.map((field, fieldIndex) => (
                                    <td key={fieldIndex} className="text-center min-w-64 border h-10">
                                        {
                                            // If field is an amount, display $ in front, and if inspection data doesnt contain the field look in device data for that field
                                            inspectionsData[index] && inspectionsData[index][field.key] ? (
                                                field.key === "test1Amount" || field.key === "test2Amount" ? (

                                                    `$${inspectionsData[index][field.key]}`) : (inspectionsData[index][field.key])

                                            ) : (deviceData[index]?.[field.key] || field.value)
                                        }

                                    </td>
                                ))
                                : inspectionFields.map((field, fieldIndex) => (
                                    // If current field key is listed below, don't place it in a text box to be edited
                                    (field.key === "deviceId" || field.key === "inspectionId" || field.key === "deviceType" || field.key === "agency" ?
                                        <td key={fieldIndex} className="text-center min-w-64 border">
                                            {inspectionsData[index]?.[field.key] ? inspectionsData[index]?.[field.key] : deviceData[index]?.[field.key]}
                                        </td>
                                
                                        :
                                
                                        // Check if the field key is one of the date fields
                                        (["test1NextDate", "test1LastDate", "test2NextDate", "test2LastDate"].includes(field.key) ?
                                            <td key={fieldIndex} className="text-center min-w-64 border">
                                                <input
                                                    type="date"
                                                    value={
                                                        inspectionsData[index][field.key]
                                                            ? new Date(inspectionsData[index][field.key]).toISOString().split("T")[0]
                                                            : ""
                                                    }
                                                    className="border rounded-md p-1 min-w-64"
                                                    onChange={(e) => handleInputChange(e, index, field.key)}
                                                />
                                            </td>
                                            :
                                            <td key={fieldIndex} className="text-center min-w-64 border">
                                                <input
                                                    type="text"
                                                    value={inspectionsData[index][field.key] || ""}
                                                    className="border rounded-md p-1 min-w-64"
                                                    onChange={(e) => handleInputChange(e, index, field.key)}
                                                />
                                            </td>
                                        )
                                    )
                                ))}
                            {editEnabled && (
                                <td className="text-center min-w-64 border px-1">
                                    <button
                                        id={`${displayedData[index]}`}
                                        className="px-4 py-1 text-center bg-red-500 text-white rounded-md hover:bg-red-600"
                                        onClick={() => handleDeleteInspection(displayedData[index].inspectionId)}
                                    >
                                        X
                                    </button>
                                </td>
                            )}
                        </tr>
                    )) 
                    
                    // If data has not loaded display loading status
                    : (
                        <tr>
                            <td colSpan={inspectionFields.length} className="text-center py-4">{listLoadingStatusMessage}</td>
                        </tr>
                    )}

                    
                </tbody>


                :


                // Devices selected
                <tbody className="w-full">
                    {displayedData.map((device, index) => (
                        <tr key={index} className="justify-center border">
                            {!editEnabled ? deviceFields.map((field, fieldIndex) => (
                                <td key={fieldIndex} className="text-center min-w-64 border align-middle p-2">
                                    {field.key === "test1Amount" ? `$${device[field.key] ? device[field.key] : "N/A"}`
                                    : 
                                    device[field.key] ? device[field.key] : (field.key === "agencyId" && inspectionsData[index]?.agency) || "N/A"
                                    }
                                </td>
                            )) 
                            //Drop Menu selections
                            : deviceFields.map((field, fieldIndex) => (
                                <td key={fieldIndex} className="text-center min-w-64 border">
                                    {field.key === "deviceClass" ? (
                                        <select
                                            value={device.deviceClass}
                                            className="min-w-64 border rounded-md p-1"
                                            onChange={(e) => handleInputChange(e, index, field.key)}
                                        >
                                            <option value="">Select Device Class</option>
                                            {deviceSubclassFields.map((deviceClass) => (
                                                <option key={deviceClass.key} value={deviceClass.key}>
                                                    {deviceClass.key}
                                                </option>
                                            ))}
                                        </select>
                                    ) : field.key === "currentSubclass" ? (
                                        <p>{device.deviceSubclass}</p>
                                    ) : field.key === "deviceSubclass" ? (
                                        <select
                                            value={device.deviceSubclass}
                                            className="w-full border rounded-md p-1"
                                            onChange={(e) => handleInputChange(e, index, field.key)}
                                        >
                                            <option value="">Select Device Subclass</option>
                                            {deviceSubclassFields.find(subclass => subclass.key === device.deviceClass)?.values.map((subclass) => (
                                                <option key={subclass} value={subclass}>
                                                    {subclass}
                                                </option>
                                            ))}
                                        </select>
                                    ) : field.key === "deviceUse" ? (
                                        <select
                                            value={device.deviceUse}
                                            className="w-full border rounded-md p-1"
                                            onChange={(e) => handleInputChange(e, index, field.key)}
                                        >
                                            <option value="">Select Device Use</option>
                                            {deviceUseFields[0].values.map((use) => (
                                                <option key={use} value={use}>
                                                    {use}
                                                </option>
                                            ))}
                                        </select>
                                    ) : field.key === "deviceType" ? (
                                        <select
                                            value={device.deviceType}
                                            className="w-full border rounded-md p-1"
                                            onChange={(e) => handleInputChange(e, index, field.key)}
                                        >
                                            <option value="">Select Device Type</option>
                                            {deviceTypeFields.map((dobType) => (
                                                <option key={dobType} value={dobType}>
                                                    {dobType}
                                                </option>
                                            ))}
                                        </select>



                                    ) : field.key === "deviceId" ? (
                                        device[field.key]
                                    )
                                    : field.key === "agencyId" ? (
                                            inspectionsData[index]?.agency
                                    )
                                    : (
                                        <input
                                            type="text"
                                            value={device[field.key] || ""}
                                            className="w-full border rounded-md p-1"
                                            onChange={(e) => handleInputChange(e, index, field.key)}
                                        />
                                    )}
                                </td>
                            ))}
                            {editEnabled && (
                                <td className="text-center min-w-64 border px-1">
                                    <button
                                        id={`${device.deviceId}`}
                                        className="px-4 py-1 text-center bg-red-500 text-white rounded-md hover:bg-red-600"
                                        onClick={() => handleDeleteDevice(device.deviceId)}
                                    >
                                        X
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>)
        );
    };
    

    return (
        <div className="px-2 h-screen w-full">
            <div className="grid grid-cols-6 grid-rows-4 border relative w-full">
                <h3 className="grid text-lg font-semibold row-start-2 justify-end pr-4 py-2 row-span-2">Building: 
                    <p className="font-normal col-start-2 pl-10">{address}</p>
                </h3>

                <div className="flex row-start-2 col-span-2 col-start-2 row-span-2 items-center gap-2 justify-center">
                    <input
                        type="radio"
                        name="List"
                        value="false"
                        checked={!showingInspections}
                        onChange={() => handleDeviceListChange(false)}
                    />
                    <label>Devices</label>
                    <input
                        type="radio"
                        name="List"
                        value="true"
                        className="ml-4"
                        checked={showingInspections}
                        onChange={() => handleDeviceListChange(true)}
                    />
                    <label>Inspections</label>
                </div>
                <div className="flex row-start-2 col-span-1 col-start-4 row-span-2 items-center gap-10">

                    <h3 className="text-lg font-semibold">Search:</h3>
                    <input type="text" className="border-2 w-full col-start-5" onChange={(e) => handleSearchChange(e.target.value)} />
                </div>
                <div className="flex row-start-2 col-span-1 col-start-5 row-span-2 items-center gap-10 px-1">
                    <select className="border-2 w-full bg-white p-1" onChange={(e) => setSearchCriteria(e.target.value)}>
                        <option value="none">None</option>
                        <option value="deviceId">Device Id</option>
                        <option value="deviceClass">Device Class</option>
                        <option value="currentSubclass">Current Subclass</option>
                        <option value="deviceSubclass">Device Subclass</option>
                        <option value="dobType">DOB Type</option>
                        <option value="deviceUse">Device Use</option>
                    </select>
                </div>
                <div className="flex row-start-2 col-start-6 justify-center items-center row-span-2 gap-6">
                    {!editEnabled ? (
                        <button className="px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600" onClick={handleEdit}>Edit</button>
                    ) : (
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600" onClick={handleSubmit}>Save</button>
                    )}
                </div>
            </div>
            <div className="flex flex-col">
                <div className="overflow-auto">
                    <table className="mb-2 ">
                        {showingInspections ?
                            <thead>
                                <tr>
                                    <th className="py-4 border-4">Inspection Number</th>
                                    <th className="py-4 border-4">Device ID</th>
                                    <th className="py-4 border-4">Device Type</th>
                                    <th className="py-4 border-4">Test1</th>
                                    <th className="py-4 border-4">Test1 Last</th>
                                    <th className="py-4 border-4">Test1 Next</th>
                                    <th className="py-4 border-4">Test1 Perform</th>
                                    <th className="py-4 border-4">Test1 Bill Type</th>
                                    <th className="py-4 border-4">Test1 Amount Due</th>
                                    <th className="py-4 border-4">Test2</th>
                                    <th className="py-4 border-4">Test2 Last</th>
                                    <th className="py-4 border-4">Test2 Next</th>
                                    <th className="py-4 border-4">Test2 Perform</th>
                                    <th className="py-4 border-4">Test2 Bill Type</th>
                                    <th className="py-4 border-4">Test2 Amount Due</th>
                                    <th className="py-4 border-4">Inspection Status</th>
                                    <th className="py-4 border-4">Car Note</th>
                                    <th className="py-4 border-4">Route ID</th>
                                    <th className="py-4 border-4">Location</th>
                                    <th className="py-4 border-4">Customer</th>
                                    <th className="py-4 border-4">Agency</th>
                                    {editEnabled && <th className="py-4 border-4">Actions</th>}
                                </tr>
                            </thead>
                            :
                            <thead>
                                <tr>
                                <th className="py-4 border-4 h-10">Device ID</th>
                                <th className="py-4 border-4">Device Class</th>
                                <th className="py-4 border-4">Current Subclass</th>
                                <th className="py-4 border-4">Device Subclass</th>
                                <th className="py-4 border-4">Device Type</th>
                                <th className="py-4 border-4">Device Use</th>
                                <th className="py-4 border-4">AgencyID</th>
                                <th className="py-4 border-4">Customer #</th>
                                <th className="py-4 border-4">Location</th>
                                <th className="py-4 border-4">Capacity</th>
                                <th className="py-4 border-4">Car Speed</th>
                                <th className="py-4 border-4">Floors</th>
                                <th className="py-4 border-4">Travel</th>
                                <th className="py-4 border-4">HoistMotor Type</th>
                                <th className="py-4 border-4">HoistMotor AC/DC</th>
                                <th className="py-4 border-4">Control Board Make</th>
                                <th className="py-4 border-4">Control Board Type</th>
                                <th className="py-4 border-4">Shaftway Door Type</th>
                                <th className="py-4 border-4">Main Machine Type</th>
                                {editEnabled && <th className="py-4 border-4">Actions</th>}
                            </tr>
                        </thead>



                    }

                    {deviceData.length > 0 ? deviceRender() : (
                        <tbody>
                            <tr className="overflow-x-scroll">
                                <td colSpan={editEnabled ? "7" : "6"} className="text-center py-4">{listLoadingStatusMessage}</td>
                            </tr>
                        </tbody>
                    )}


                </table>
                    </div>
            </div>
        </div>
    );
};

export default BuildingDeviceEditing;
